
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ContactCardView',
  props: {
    src: {
      type: String,
      defalut: ''
    },
    title: {
      type: String,
      defalut: ''
    },
    contactNumber: {
      type: String,
      defalut: ''
    },
    href: {
      type: String,
      defalut: ''
    }
  }
})
